// generated by the plop

import { PaginatorModel, PROGRESS_STATUSES } from 'symbols';
import { StandModel, StandsCountModel, StandStatusExpectBackend } from '../../symbols';

export interface StandListStateModel {
  standList: PaginatorModel<StandModel>;
  loadStandListStatus: PROGRESS_STATUSES;
  lastOpenedDocId: string;
  standStatusList: StandStatusExpectBackend[];
  scrollPosition: number;
  standsCount: StandsCountModel;
}

export const STAND_LIST_STATE_DEFAULT: StandListStateModel = {
  standList: {
    data: [],
    links: null,
    meta: null
  },
  loadStandListStatus: PROGRESS_STATUSES.NOT_INITIALIZED,
  lastOpenedDocId: null,
  standStatusList: [],
  scrollPosition: 0,
  standsCount: {
    acceptedCount: 0,
    issuedCount: 0
  }
};
